module.exports = __webpack_public_path__ + "img/cmg-labs-1.e158013f.webp";